/**
 * University Page Routes
 *
 * Defines routing configuration for the USABG University page.
 * Requires authentication for access.
 *
 * @module pages/University/routes
 */

import { UniversityPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(UniversityPage, '/usabg-university', [new RequiresAuthGuard(true)], {
    name: 'USABG University',
  }),
]
